import axios from 'axios'
import {execute_generator} from "@/networking";
import {msg_root} from "@/networking/messages";

const client = axios.create({
    baseURL: process.env.VUE_APP_API_MESSAGE_URL,
    json: true
})

export default {
    async execute (method, resource, data) {

        let accessToken = localStorage.getItem('jwt');

        return client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            return req.data
        })
    },
    getInbound (searchString) {
        return this.execute('post', '/messages/search/inbound', { imei: searchString })
    },
    getSensorMsgs (searchString, from, to) {
        return this.execute('post', '/messages/search/sensordata', { podId: searchString, fromDate: from, toDate: to })
    },
    enable_troubleshooting_mode_support(imei) {
        return this.execute('patch', '/messages/enableTroubleshootingModeSupport/' + imei)
    },
    disable_troubleshooting_mode_support(imei) {
        return this.execute('patch', '/messages/disableTroubleshootingModeSupport/' + imei)
    }
}

